// LfContent.js
import React, { useState, useEffect } from 'react';
import { Table, Button, Image, message, Input, Row, Col, Cascader, Segmented, Divider, InputNumber, FloatButton } from 'antd';
import axios from 'axios';
import { formatDate } from './Util.js'; 
import { BASE_URL } from './Config.js';
import { Area } from './Area.js';
import './LfContent.css';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn');

const LfContent = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [contentId, setContentId] = useState('');
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [areaId, setAreaId] = useState('');
  const [segmentValue, setSegmentValue] = useState('内容');
  const [getPageMaxNum, setGetPageMaxNum] = useState(0);
  const [lastTime, setLastTime] = useState(0);
  const [lastCount, setLastCount] = useState(0);
  
  useEffect(() => {
    setAreaId("1");
  }, []);


  const fetchData = async (page=1, size = 10) => {
    try {
      // 发送请求获取数据
      let url = `${BASE_URL}/xhg/getLfContent?area_id=${areaId}&page_no=${page}&page_size=${size}`;
      
      if (contentId.trim() !== '') {
        url += `&id=${contentId.trim()}`;
      }

      const response = await axios.get(url);
      
      console.log(response);

      if (!response.data.data.lf_content) {
        return
      }
      
      const formattedData = response.data.data.lf_content.map(item => ({
        ...item,
        create_time_text: formatDate(item.create_time),
        update_time_text: formatDate(item.update_time),
        update_time: item.update_time,
      }));
      console.log(response.data.data.lf_num);
      setData(formattedData);
      setCurrentPage(page);
      setTotalItems(response.data.data.lf_num);
    } catch (error) {
        message.error('获取数据失败: '+ error, 5);
    }
  };

  const resetQueryData = () => {
    setContentId('');
    setAreaId('1');
  };

  const onChangePageMaxNum = (e) => {
    console.log(e);
    setGetPageMaxNum(e);
  };

  const getLFData = async () => {
    try {
        // 发送请求获取数据
        let url = `${BASE_URL}/xhg/getContent`;
  
        const response = await axios.post(url, {
            area_id: areaId,
            page_no: Number(getPageMaxNum),
        });
        
        console.log(response);
      } catch (error) {
          message.error('获取数据失败: '+ error, 5);
      }
  };

  const columns = [
    // 定义表格列
    { title: 'tid', dataIndex: 'tid', key: 'tid', width:50, fixed: 'left' },
    { title: '标题', dataIndex: 'title', key: 'title', width:100 },
    { title: '价格', dataIndex: 'price', key: 'price', width:100 },
    { title: '内容', dataIndex: 'content', key: 'content', width:200, render: (text) => (
      <div style={{ 
        whiteSpace: 'pre-wrap', 
        wordBreak: 'break-all',
        lineHeight: '1.5' 
      }}>
        {text}
      </div>
    ), },
    { title: '图片', dataIndex: 'img_urls', key: 'img_urls', width:150,
    render: (imageUrls) => {
            // 1. 基础判断：确保有数据且不全为空字符串
            const hasImages = imageUrls && Array.isArray(imageUrls) && imageUrls.some(url => url && url.trim() !== '');
            
            if (!hasImages) {
              return null; // 或者返回 '暂无图片'
            }
    
            return (
              // 2. 创建 Flex 容器
              <div style={{ 
                display: 'flex',       // 启用 Flex 布局
                flexWrap: 'wrap',     // 允许换行
                gap: '8px',            // 图片之间的间距
                padding: '4px 0'       // 上下留少许边距
              }}>
                {imageUrls.map((url, index) => {
                  // 3. 过滤掉空链接
                  if (!url || url.trim() === '') return null;
                  
                  return (
                    // 4. 使用有赞的 Image 组件 (或原生 img)
                    <Image 
                      key={`image_${index}`} 
                      src={url.trim()} 
                      alt={`图片${index + 1}`} 
                      // 5. 统一图片样式
                      style={{ 
                        width: '60px',        // 固定宽度
                        height: '60px',       // 固定高度，做成正方形预览
                        borderRadius: '4px',  // 加点圆角
                        objectFit: 'cover',   // 保持比例裁剪，不拉伸
                        display: 'block'      // 消除图片底部空隙
                      }} 
                      // 如果使用的 UI 框架支持点击预览，可以在这里配置
                      // preview={{ scaleStep: 0.5 }} 
                    />
                  );
                })}
              </div>
            );
          }, 
    },
    { title: '详细地址', dataIndex: 'location_detail', key: 'location_detail', width:150 },
    { title: '地点', dataIndex: 'location', key: 'location', width:100 },
    { title: '联系方式', dataIndex: 'contact', key: 'contact', width:150, fixed: 'right', },
  ];

  const onChangeArea = (e) => {
    console.log(e);
    if (e.length === 1) {
        setAreaId(String(e[0]));
    } else if (e.length === 2) {
        let area_id = e[0]+'.'+e[1]
        setAreaId(String(area_id));
    } else {
        message.error('区域id错误: '+ e, 5);
        return
    }

    getQueryInfo(areaId);
  };

  const getQueryInfo = async (area) => {
    try {
        // 发送请求获取数据
        let url = `${BASE_URL}/xhg/getQueryInfo?area=`+area;
  
        const response = await axios.get(url);
        
        console.log(response);
        
        // 修改：数据在 response.data.data 下（与 fetchData 保持一致）
        const { last_time, count } = response.data.data;
        
        // 修改：last_time 是毫秒时间戳，需要格式化
        const formattedTime = formatDate(last_time);
        
        setLastTime(formattedTime);
        setLastCount(count);
      } catch (error) {
          message.error('获取数据失败: '+ error, 5);
      }
  };

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };


  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
  });


  return (
    <div>
        <div>
          <Segmented size="large" options={['内容', '爬取数据']} value={segmentValue} onChange={setSegmentValue} />
        </div>
    

    {segmentValue === '内容' && (
    <div>
    <Divider />
      <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >
          <Col className='gutter-row' span={8}>
          <Cascader options={Area} onChange={onChangeArea} defaultValue={[1]} placeholder="请选择城市" />
          </Col>
          <Col className='gutter-row' span={8}>
            <Input
            addonBefore="内容id"
            placeholder="内容id"
            value={contentId}
            onChange={(e) => setContentId(e.target.value)}
            style={{ marginBottom: '10px', marginRight: '10px' }}
          />
          </Col>
          </Row>
       
          <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >

            <Col className='gutter-row' offset={16} span={8}>
              <Button type="primary" onClick={() => fetchData(currentPage)} style={{ marginBottom: '10px' }}>查询</Button>
              <Button type="default" onClick={() => resetQueryData()} style={{ marginLeft: '10px', marginBottom: '10px' }}>重置</Button>
            </Col>
          </Row>
      
      <div className="table-scroll-box">
        <Table
          dataSource={data}
          columns={columns}
          pagination={{
            onChange: (page, size) => fetchData(page, size),
            current: currentPage,
            defaultPageSize: 10,
            pageSizeOptions: ['10', '20', '30', '50'],
            showSizeChanger: true,
            total: totalItems,
          }}
          scroll={{ x: 1500, y: 1200 }}
          rowKey="id"
          rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        />
      </div>
    </div>
    )}

    {segmentValue === '爬取数据' && (
         <div>
         <Divider />
         <Row
             gutter={{
               xs: 8,
               sm: 16,
               md: 24,
               lg: 32,
             }}
           >
             <Col className='gutter-row' span={8}>
                <Cascader options={Area} onChange={onChangeArea} defaultValue={[1]} placeholder="请选择城市" />
             </Col>

             <Col className='gutter-row' span={8}>
                <InputNumber min={0} max={10} defaultValue={0} onChange={onChangePageMaxNum} />
             </Col>
             </Row>
          
             <Row
             gutter={{
               xs: 8,
               sm: 16,
               md: 24,
               lg: 32,
             }}
           >
   
               <Col className='gutter-row' offset={16} span={8}>
                 <Button type="primary" onClick={() => getLFData()} style={{ marginBottom: '10px' }}>爬取数据</Button>
                 <Button type="default" onClick={() => resetQueryData()} style={{ marginLeft: '10px', marginBottom: '10px' }}>重置</Button>
               </Col>
             </Row>

             <Row
             gutter={{
               xs: 8,
               sm: 16,
               md: 24,
               lg: 32,
             }}
           >
   
               <Col className='gutter-row' offset={16} span={4}>
                <Input
                  addonBefore="上次爬取时间"
                  value={lastTime}
                  disabled
                  style={{ marginBottom: '10px', marginRight: '10px' }}
                />

                <Input
                  addonBefore="上次爬取数量"
                  value={lastCount}
                  disabled
                  style={{ marginBottom: '10px', marginRight: '10px' }}
                />
               </Col>
             </Row>
        
       </div>
    )}

    <FloatButton.BackTop 
      target={() => document.querySelector('.table-scroll-box .ant-table-body')}
      visibilityHeight={100}
      duration={500}
    />
    </div>
  );
};

export default LfContent;
